import { Form } from 'antd';
import styled from 'styled-components';

const { Item } = Form;

export const StyledReadonlyFormItem = styled(Item)`
    --height: 24px;

    color: var(--gray-9);
    margin-bottom: 0;
    justify-content: flex-end;
    flex: 1;

    .ant-form-item-label > label {
        height: var(--height);
        max-height: auto;
        min-height: auto;
    }

    .ant-form-item-control-input {
        min-height: auto;
        justify-content: flex-end;
    }

    .ant-form-item-control-input-content {
        flex: 1;
        word-break: break-all;
        border-radius: 2px;
        padding-inline: 8px;
        border: 1px solid var(--brand-5);
        width: 100%;
        max-width: 380px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        min-height: var(--height);
    }

    .anticon-close {
        color: var(--brand-6);
    }
`;

export const StyledWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const StyledIconWrapper = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: var(--brand-7);
    background-color: var(--brand-1);
    border-radius: 4px;
    width: 24px;
    height: 24px;
    font-size: 16px;

    svg {
        font-size: 16px;
        color: var(--brand-6);
    }
`;

export const StyledFormSectionTitle = styled.h2`
    font-size: 16px;
    line-height: 24px;
    font-weight: 600;
    margin-bottom: 0;
`;
